<template>
  <div @click="$emit('openmodel')">
    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          <span class="headline"> {{ title }} </span>
          <v-spacer></v-spacer>
          <v-icon @click="$emit('openmodel')">close</v-icon>
        </v-card-title>
        <v-card-text v-if="!deleteModal">
          <v-container>
            <v-row>
              <h2>Are you sure do you want to delete?</h2>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-text v-if="deleteModal">
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  disabled
                  label="Campaign"
                  v-model="campaign_id"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="data.name"
                  label="Name*"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                type="number"
                  v-model="data.weight"
                  label="Weight*"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-switch
                  v-model="data.is_boosted"
                  :label="`Is Boosted`"
                ></v-switch>
              </v-col>
            </v-row>
          </v-container>
          <small>*indicates required field</small>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="darken-1" text @click="$emit('openmodel')">Close</v-btn>
          <v-btn
            color="darken-1"
            class="primary"
            text
            @click="createTiers()"
            >{{ btnTitle }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import api from '@/clients/prizingapi/tiers'
import prizingApi from '@/clients/prizingapi/prizing'
import { mapGetters } from 'vuex'

export default {
  props: ['title', 'btnTitle', 'item', 'deleteModal', 'prizing_id'],
  data: () => ({
    prizing: [],
    dialog: true,
    switch1: false,
    campaign_id: '',
    data: {
      prizing_id: 'fsdfsdfsd',
      name: '',
      weight: '',
      is_boosted: false
    },
    tier_id: ''
  }),
  mounted () {
    this.campaign_id = this.$route.params.id
    // console.log(this.prizing_id)
    // console.log('00000', this.$route.params.id)
    this.editData()
    this.getPrizing()
  },
  computed: {
    ...mapGetters({
      vg_activeBusinessBrandingAndLogo: 'auth/activeBusinessBrandingAndLogo'
    })
  },
  methods: {
    /**
     * To create a new prizing
     * @function
     * @returns {object} - A promise that will either return an error message or perform an action.
     */
    createTiers () {
      this.data.prizing_id = this.campaign_id
      console.log('this.data', this.data)
      this.spinner(true)
      if (this.btnTitle === 'Save') {
        api
          .createTier(this.data)
          .then(res => {
            console.log('res', res)
            this.data = {}
            this.spinner(false)
            this.$emit('getTiers')
            return this.snackbar({ text: 'Tier added successfully' })
          })
          .catch(error => {
            console.log(error)
            this.spinner(false)
            return this.snackbar({ text: error.response.data.msg })
          })
      } else if (this.btnTitle === 'Update') {
        api
          .editTier(this.tier_id, this.data)
          .then(res => {
            this.data = {}
            this.spinner(false)
            this.$emit('getTiers')
            return this.snackbar({ text: 'Tier edit successfully' })
          })
          .catch(error => {
            console.log(error)
            this.spinner(false)
            return this.snackbar({ text: error.response.data.msg })
          })
      } else if (this.btnTitle === 'Delete') {
        api
          .deleteTier(this.tier_id)
          .then(res => {
            this.data = {}
            this.spinner(false)
            this.$emit('getTiers')
            return this.snackbar({ text: 'Tier deleted successfully' })
          })
          .catch(error => {
            console.log(error)
            this.spinner(false)
            return this.snackbar({ text: error.response.data.msg })
          })
      }
    },

    /**
     * To get a list of prizing
     * @function
     * @returns {object} - A promise that will either return an error message or perform an action.
     */
    getPrizing () {
      this.spinner(true)
      prizingApi
        .getPrizing()
        .then(res => {
          this.prizing = res.data.payload
          console.log(this.prizing)
          this.spinner(false)
        })
        .catch(error => {
          console.log(error)
          this.spinner(false)
          return error
        })
    },
    /**
     * Get data by id and fill in textbox
     * @function
     */
    editData () {
      this.data.name = this.item.name
      this.data.prizing_id = this.item.prizing_id
      this.data.weight = this.item.weight
      this.data.is_boosted = this.item.is_boosted
      this.tier_id = this.item.id
    }
  }
}
</script>

<style lang="scss" scoped></style>
